export enum IdType {
  MyKad = 1,
  Passport = 2,
  Army = 4,
  Police = 5,
  MyPR = 7,
  BirthCertificate = 12,
  Mm2h = 13,
  WorkVisa = 14,
  StudentVisa = 15,
  DependentVisa = 16,
}
